import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import PageTitle from '../../components/pagetitle/PageTitle'
import BlogSection from '../../components/BlogSection/BlogSection.jsx'
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import logo from '../../images/logo-2.svg';
import './BlogPage.css';

const BlogPage = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Regenerative Medicine Blog | Medical Insights & Research</title>
                <meta name="description" content="Expert insights on stem cell therapy, regenerative medicine, orthobiologics, and pain management from Dr. Eugene Pereira. Latest research, treatment updates, and patient success stories." />
                <meta name="keywords" content="regenerative medicine blog, stem cell therapy research, orthobiologics articles, pain management insights, medical research updates" />
                <meta property="og:title" content="Regenerative Medicine Blog - Medical Insights & Research" />
                <meta property="og:description" content="Expert insights on stem cell therapy and regenerative medicine from Dr. Eugene Pereira." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/blog" />
                <link rel="canonical" href="https://ampedtherapeutics.com/blog" />
            </Helmet>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={logo} />
            <PageTitle
                pageTitle={'Medical Insights & Research'}
                pagesub={'Blog'}
                customClass="blog-page-title"
                customStyle={{
                    backgroundImage: 'url(/blog-banner.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            />
            <BlogSection limit={20} showViewAll={false} />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogPage;

